import { useTranslation } from 'react-i18next';
import AppointmentCard from './AppointmentCard';
import PlaceholderCard from '../../../shared/PlaceholderCard';
import { Stack } from '../../../shared/layouts';
import DeleteAppointmentModal from './DeleteAppointmentModal';
import { useContext, useState } from 'react';
import { formatAppointmentDate } from '../../../../utils/dateHelpers';
import axios from 'axios';
import MessagebarContext from '../../../../context/MessagebarContext';

const CalendarWidget = ({ onRefresh, list }) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [deleteable, setDeleteable] = useState(null);
  const { setAlertMessage, setSuccesMessage } = useContext(MessagebarContext);

  const handleDelete = () => {
    setIsSubmitting(true);

    axios({
      method: 'DELETE',
      url: `/appointment/${deleteable.id}`
    })
      .then(() => {
        setSuccesMessage(t('De afspraak is verwijderd!'));
      })
      .catch(() => {
        setAlertMessage();
      })
      .finally(() => {
        onRefresh().finally(() => {
          setDeleteable(null);
          setIsSubmitting(false);
        });
      });
  };

  return list?.length === 0 ? (
    <PlaceholderCard
      title={t('Behoefte aan een gesprek met één van onze adviseurs?')}
      actionText={t('Plan afspraak')}
      actionUrl={'/calendar/new'}
    />
  ) : (
    list?.length > 0 && (
      <Stack space={'l'}>
        <DeleteAppointmentModal
          isOpen={!!deleteable}
          onRequestClose={() => setDeleteable(null)}
          handleSubmit={() => handleDelete()}
          currentAppointment={deleteable}
          isSubmitting={isSubmitting}
          appointmentDate={deleteable?.startDate}
        />
        {list.map(props => {
          const {
            fullDate: startDate
          } = formatAppointmentDate(props?.start_at);

          return (
            <AppointmentCard
              key={props?.id}
              onDelete={() => {
                setDeleteable({
                  startDate: startDate,
                  ...props,
                });
              }}
              {...props}
            />
          );
        })}
      </Stack>
    )
  );
};

export default CalendarWidget;
